/*    
<summary>
  This functional component "EditStatusPopupHOC" provides props to the child component.
  1. State "showEditStatusPopup" that manages the show/hide of pop up
  2. Function "editStatusToggleHandler" to toggle the show/hide popup state "showEditStatusPopup"
  Developer:Aashish Singh, Created Date:06-June-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const EditStatusPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showEditStatusPopup, setShowEditStatusPopup] = useState<boolean>(false);

    const editStatusToggleHandler = () => {
      setShowEditStatusPopup(!showEditStatusPopup);
    };

    return (
      <Component
        showEditStatusPopup={showEditStatusPopup}
        editStatusToggleHandler={editStatusToggleHandler}
        {...props}
      />
    );
  };

export default EditStatusPopupHOC;
